const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const resetPassword = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'RESET_PASSWORD_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'RESET_PASSWORD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default resetPassword;